import DOMPurify from 'dompurify';

/**
 * Sanitiza HTML para prevenir XSS
 * @param {string} dirty - String potencialmente perigosa
 * @returns {string} String sanitizada
 */
export function sanitizeHtml(dirty) {
  if (!dirty) return '';
  return DOMPurify.sanitize(dirty, {
    ALLOWED_TAGS: ['b', 'i', 'em', 'strong', 'a', 'p', 'br'],
    ALLOWED_ATTR: ['href', 'target'],
  });
}

/**
 * Remove completamente todas as tags HTML
 * @param {string} dirty - String com HTML
 * @returns {string} String sem HTML
 */
export function stripHtml(dirty) {
  if (!dirty) return '';
  return DOMPurify.sanitize(dirty, { ALLOWED_TAGS: [] });
}

/**
 * Escapa caracteres especiais para exibição segura
 * @param {string} text - Texto para escapar
 * @returns {string} Texto escapado
 */
export function escapeHtml(text) {
  if (!text) return '';
  const map = {
    '&': '&amp;',
    '<': '&lt;',
    '>': '&gt;',
    '"': '&quot;',
    "'": '&#x27;',
    '/': '&#x2F;',
  };
  return text.replace(/[&<>"'/]/g, (char) => map[char]);
}
